import { createApiRef } from '@backstage/core-plugin-api';
import type { McpTool, McpServerRecord, McpServerInput, CopilotPersona, PersonaInput } from './types';

export interface ToolsRegistryApi {
  getTools(): Promise<McpTool[]>;
  getPersonas(): Promise<CopilotPersona[]>;
  getPersona(id: string): Promise<CopilotPersona>;
  createPersona(input: PersonaInput): Promise<{ id: string }>;
  updatePersona(id: string, input: Partial<PersonaInput>): Promise<void>;
  deletePersona(id: string): Promise<void>;

  /** MCP Server marketplace */
  getServers(): Promise<McpServerRecord[]>;
  getAllServers(): Promise<McpServerRecord[]>;
  createServer(input: McpServerInput): Promise<{ id: string }>;
  updateServer(id: string, input: Partial<McpServerInput & { enabled?: boolean }>): Promise<void>;
  deleteServer(id: string): Promise<void>;
  getPersonaServers(personaId: string): Promise<string[]>;
  setPersonaServers(personaId: string, serverIds: string[]): Promise<void>;
}

export const toolsRegistryApiRef = createApiRef<ToolsRegistryApi>({
  id: 'plugin.tools-registry.service',
});
